import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import { getDefaultModalData, getDefaultModalUI } from "components/custom-ui/CustomModal/components/FirstTimeLoginModal";

/**
 * @name CaptureSoftTokensIdentityVerificationEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Logging In".
 */
export default function CaptureSoftTokensIdentityVerificationEntered(props) {
    const modalUI = getDefaultModalUI();
    const modalData = getDefaultModalData();

    const _modalData = BCMSStateManagerCRUD.init({ data: modalData, ui: modalUI })
    .update([ "ui", "step" ], 2)
    .update([ "data", "passcode" ], "9999")
    .submit();

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "DemoUser")
    .update([ "password" ], "123456789012")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .update([ "modal", "data" ], _modalData)
        .submit();

    return <LoginPage data={ data } ui={ ui } />
}